import { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import styles from "./ThemeToggle.module.css";

function ThemeToggle() {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <button
      className={styles["theme-toggle"]}
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
    >
      {theme === "light" ? (
        <GlobalIcon iconName="MoonIcon" className={styles["theme-icon"]} />
      ) : (
        <GlobalIcon iconName="SunIcon" className={styles["theme-icon"]} />
      )}
    </button>
  );
}

export default ThemeToggle;

